"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _slice = require("@lce/slice");

var _i18n = require("@lce/i18n");

var _toUpper2 = _interopRequireDefault(require("lodash/toUpper"));

var _reactFeather = require("react-feather");

var Styled = _interopRequireWildcard(require("./MinimumSubtotalModal.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

var MinimumSubtotalModal = function MinimumSubtotalModal(_a) {
  var isOpen = _a.isOpen,
      onClose = _a.onClose,
      heading = _a.heading,
      message = _a.message;
  var t = (0, _i18n.useTranslation)().t;
  return React.createElement(Styled.Modal, {
    closeIcon: React.createElement(_reactFeather.X, {
      color: "black",
      width: "16px"
    }),
    isOpen: isOpen,
    onClose: onClose
  }, React.createElement(Styled.Box, null, React.createElement(Styled.ErrorPizza, null), React.createElement(Styled.Headline, {
    as: "h3",
    "data-testid": "MinimumModal__headline"
  }, heading), React.createElement(_slice.Text, {
    as: "p",
    fontSize: "18px",
    lineHeight: 1.2,
    mb: "48px",
    pl: [0, 140],
    pr: [0, 140]
  }, message), React.createElement(_slice.Anchor, {
    as: "button",
    color: "orange",
    "data-testid": "MinimumModal__close-button",
    fontSize: "18px",
    onClick: onClose
  }, (0, _toUpper2["default"])(t('Common.Close')))));
};

var _default = MinimumSubtotalModal;
exports["default"] = _default;